import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: 
      `relative my-2 shadow-lg text-white bg-gray-100 bg-opacity-20 rounded-md px-4`
     }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("button", _hoisted_1, [
    _createVNode("div", {
      class: 
        ` absolute left-0 top-0 right-0 bottom-0 correctness-display transition-all rounded-md
        ${_ctx.showResult &&
          _ctx.isCorrect &&
          `border-green-300 border-opacity-70 border-2 border-t-4`}
        ${_ctx.showResult &&
          !_ctx.isCorrect &&
          `border-red-400 border-opacity-70 border-2 border-t-4`}`
      
    }, null, 2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}